import React, { useEffect, useState, useRef } from "react";
import UserWrapper from "./staticpage.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import StaticpageServices from "../../api/StaticpageServices";
import Toaster from "../../components/common/Toaster";
import StaticPageForm from "../../components/staticpage/StaticPageForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const StaticPageEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const hasParam = props.match.params.id;

  const toaster = useRef();

  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      StaticpageServices.view(params)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          setEditedData(data.data);
        })
        .catch(err => {
          if (toaster.current) toaster.current.error(err.message);
        });
    }
  }, []);

  const submitFormHandler = (data, action) => {
    setIsLoading(true);
    if (action === "add") {
      const params = {
        title: data.title,
        content: data.content
      };
      StaticpageServices.add(params)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          if (data.status) {
            if (toaster.current) toaster.current.success(data.message);
            setTimeout(() => {
              props.history.push("/static-page");
            }, 1000);
          } else {
            if (toaster.current) toaster.current.error(data.message);
          }
          setIsLoading(false);
        })
        .catch(err => {
          if (toaster.current) toaster.current.error(err.response);
          setIsLoading(false);
        });
    } else if (action === "edit") {
      const params = {
        id: data.id,
        title: data.title,
        content: data.content
      };
      StaticpageServices.edit(params)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          if (data.status) {
            if (toaster.current) toaster.current.success(data.message);
            setTimeout(() => {
              props.history.push("/static-page");
              if (params.id == 5) window.location.reload(false);
            }, 1000);
          } else {
            if (toaster.current) toaster.current.error(data.message);
          }
          setIsLoading(false);
        })
        .catch(err => {
          if (toaster.current) toaster.current.error(err.response);
          setIsLoading(false);
        });
    }
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.staticpage"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.staticpage",
              url: "/static-page"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/static-page")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Page
            </div>
          </div>
          <div className="roe-card-body">
            <StaticPageForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
      <Toaster ref={toaster} />
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(StaticPageEdit);
